@use "./styles/variables" as vars;

.page {
  width: min(100%, 1404px);
  min-height: 100vh;
  margin-inline: auto;
  overflow-x: clip;
  background: vars.$color-page;
}

.brandPanel {
  width: min(100%, 1264px);
  margin-inline: auto;

  picture {
    display: block;
  }
}

.brandBanner {
  display: block;
  width: 100%;
  height: auto;
}

.formPanel {
  min-width: 0;
  background: vars.$color-page;
}

